// extracted by mini-css-extract-plugin
export var header = "customerSuccessShort-module--header--2A-Fs";
export var gray = "customerSuccessShort-module--gray--1Yjnq";